export class AppErrorModel {
  errorNumber!: number;
  message!: string;
  friendlyMessage!: string;
}
